import { Component, OnInit } from '@angular/core';
import {GiftCardsService} from "../../../services/gift-cards.service";
import {ActivatedRoute, Params} from "@angular/router";
import {GiftCardBrand, GiftCardBrandCategory} from "../../../dto/order";
import {PrevNextModel} from "../../../models/prev-next-model";
import {ToastService} from "angular-toastify";
import {DatePipe, Location} from "@angular/common";
import {ContentRowField} from "../../../shared/content-row/content-row.component";
import {Customer} from "../../../dto/customer";
import {toDateString} from "../../../providers/app-date-adapter";

@Component({
  selector: 'app-gift-card-brand-details',
  templateUrl: './gift-card-brand-details.component.html',
  styleUrls: ['./gift-card-brand-details.component.css']
})
export class GiftCardBrandDetailsComponent implements OnInit {
  brandId: number;
  brand: GiftCardBrand;

  prevNext: PrevNextModel;
  isLoadingBrand: boolean;
  brandCategories: GiftCardBrandCategory[];

  constructor(
    private giftCardsService: GiftCardsService,
    private route: ActivatedRoute,
    private _toastService: ToastService,
    private location: Location,

  ) { }

  clearData() {
    this.prevNext = null;
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      const idParam = params['id'];
      this.brandId = idParam;
      this.clearData();
      this.initComponent(idParam);

    });
  }

  returnBack() {
    this.location.back();
  }


  fieldsBrand= [

    { header: 'Slug', cell: (row) => `${row.slug}` } as ContentRowField<GiftCardBrand>,
    { header: 'Name', cell: (row) => `${row.name}` } as ContentRowField<GiftCardBrand>,

    { header: 'Discount Internal', cell: (row) => `${row.discount} %`} as ContentRowField<GiftCardBrand>,
    { header: 'User discount', cell: (row) => `${row.userDiscount} %`} as ContentRowField<GiftCardBrand>,
    { header: 'Enabled in App', cell: (row) => `${row.userIsEnabled}`} as ContentRowField<GiftCardBrand>,
    { header: 'Logo URL', isExternalLink: true, link: (row) => `${row.logoUrl}`, cell: (row) => `Logo` } as ContentRowField<GiftCardBrand>,
    { header: 'Gift Card URL', isExternalLink: true, link: (row) => `${row.giftCardUrl}`, cell: (row) => `Gift Card` } as ContentRowField<GiftCardBrand>,
    { header: 'Currency', cell: (row) => `${row.currency}` } as ContentRowField<GiftCardBrand>,
    { header: 'Countries', cell: (row) => `${row.countriesServed}` } as ContentRowField<GiftCardBrand>,
    { header: 'Category', cell: (row) => `${row.category?.nameEn}` } as ContentRowField<GiftCardBrand>,
    { header: 'TOS info', cell: (row) => `${row.termsAndConditionsCopy}` } as ContentRowField<GiftCardBrand>,
    { header: 'TOS url', cell: (row) => `${row.termsAndConditionsUrl}` } as ContentRowField<GiftCardBrand>,
    { header: 'Sort Order', cell: (row) => `${row.sortOrder}` } as ContentRowField<GiftCardBrand>,

  ]  as ContentRowField<GiftCardBrand>[];

  private initComponent(brandId: number) {
    this.getBrandData(brandId);
  }

  private getBrandData(brandId: number) {
    this.isLoadingBrand = true;

    this.giftCardsService.getBrandCategories().subscribe(data => {
      this.brandCategories = data;


      this.giftCardsService.getBrand(brandId)
        .subscribe(result => {
          this.brand = result;

          this.brand.category = this.brandCategories.find(value => value.id == this.brand.categoryId);

          this.isLoadingBrand = false;

        }, error => {
          this._toastService.error('Unable to load gift card brand: ' + error.message);
        });

    });
  }

  editEnabled() {
    return true;
  }
}
